import React, { useEffect, useState } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { Box,Container,Card,TextField,Paper,Typography,Grid,Divider,MenuItem,Button, touchRippleClasses, listItemButtonClasses} from '@mui/material';
import poo from "./assets/bg.webp";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import Autocomplete from "react-google-autocomplete";
import MicIcon from "@mui/icons-material/Mic";
import CloseIcon from '@mui/icons-material/Close';
import animation from '../src/animation.gif'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';
import { Global } from '@emotion/react';
import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { grey } from '@mui/material/colors';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import pg from './img/pg.webp'
import LocalAirportIcon from '@mui/icons-material/LocalAirport';
import Diversity2Icon from '@mui/icons-material/Diversity2';
import PersonIcon from '@mui/icons-material/Person';
import EmojiSymbolsIcon from '@mui/icons-material/EmojiSymbols';
import BrushIcon from '@mui/icons-material/Brush';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import BusAlertIcon from '@mui/icons-material/BusAlert';
import HandymanIcon from '@mui/icons-material/Handyman';
import StoreIcon from '@mui/icons-material/Store';
import StyleIcon from '@mui/icons-material/Style';
import HomeIcon from "@mui/icons-material/Home";
import property from "./img/property.webp";
import SearchIcon from "@mui/icons-material/Search";
import AddBusinessOutlinedIcon from '@mui/icons-material/AddBusinessOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import LandslideIcon from '@mui/icons-material/Landslide';
import rr from "../src/img/penter.png";

import ten from '../src/buildingimg/ten.jpg'



const drawerBleeding = 56;
const Root = styled('div')(({ theme }) => ({
  height: '100%',
  backgroundColor: grey[100],
  ...theme.applyStyles('dark', {
    backgroundColor: theme.palette.background.default,
  }),
}));

const StyledBox = styled('div')(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.applyStyles('dark', {
    backgroundColor: grey[800],
  }),
}));





const VoiceToText = (props) => {



  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition
  } = useSpeechRecognition();

    const navigate = useNavigate()

    let [search, setSearch]  =  useState("");
    const [city, setCity]  =  useState("PUNE");
    let [open,setOpen] = useState(false);
    let [categoryList, setCategoryList] = useState([]);


  if (!browserSupportsSpeechRecognition) {
    return <span>Browser doesn't support speech recognition.</span>;
  }




   function toggleDrawer(newOpen) {
    setOpen(true)
  };

  function toggleDrawerr(newOpen)  {
    setOpen(false)
  };






  return (
    <div>
          <Box sx={{ display: { xs: "none", sm: "none", md: "block" },mt:0.3 }}>
            
            <Box
              sx={{
                display: { xs: "none", sm: "none" ,md:'block'},
                height: 340,
                background: "#00337b",
                backgroundImage: `url(${poo})`,
                width: "100%",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                objectFit: "cover",
              }}
            >
              <Container maxWidth="xl">
                <br />
                <br />
              </Container>
            </Box>

            <Box sx={{ minHeight: 50, background: "#ffffff" }}>
              <Container maxWidth="xl">
                <br />
                <br />
                <Card
                  sx={{
                    
                    display: { xs: "none", sm: "block" },
                    position: "relative",
                    height: 130,
                    marginLeft: { sm: "1%", md: "10%" },
                    marginRight: { sm: "1%", md: "10%" },
                    backgroundColor: "rgba(0, 143, 251,0.5)",
                    marginTop: -14,
                    borderBottomLeftRadius:37,
                    borderBottomRightRadius:37,
                  }}
                >
                  <Box sx={{ width: "100%", mt: 2, mb: 2 }}>
                    <Grid container spacing={2}>

                      <Grid item size={{ xs: 2 }}>
                        <Typography
                          textAlign="center"
                          onClick={()=>navigate('/properties')}
                          sx={{
                            color:'#008ffb',
                            fontSize: 16,
                            fontWeight: "bold",
                            fontFamily: "sans-serif",
                            color:'#fff'
                            //color: this.state.value == "buy" ? "#00337b" : "",
                          }}
                        >
                         Plots
                        </Typography>
                      </Grid>

                        <Grid item size={{ xs: 2 }}>
                        <Typography
                          textAlign="center"
                         onClick={()=>navigate('/properties')}
                          sx={{
                            color:'#008ffb',
                            fontSize: 16,
                            fontWeight: "bold",
                            fontFamily: "sans-serif",
                            color:'#fff'
                            //color: this.state.value == "buy" ? "#00337b" : "",
                          }}
                        >
                         Rental
                        </Typography>
                      </Grid>
                      <Grid item size={{ xs: 2 }}>
                        <Typography
                          textAlign="center"
                           onClick={()=>navigate('/properties')}
                          sx={{
                            color:'#fff',
                            fontSize: 16,
                            fontWeight: "bold",
                            fontFamily: "sans-serif",
                            //color: this.state.value == "rent" ? "#00337b" : "",
                          }}
                        >
                         Flats
                        </Typography>
                      </Grid>
                      <Grid item size={{ xs: 2 }}>
                        <Typography
                          textAlign="center"
                        onClick={()=>navigate('/properties')}
                          sx={{
                            color:'#fff',
                            fontSize: 16,
                            fontWeight: "bold",
                            fontFamily: "sans-serif",
                            //color: this.state.value == "pg" ? "#00337b" : "",
                          }}
                        >
                        Land
                        </Typography>
                      </Grid>
                      <Grid item size={{ xs: 2 }}>
                        <Typography
                          textAlign="center"
                         onClick={()=>navigate('/properties')}
                          sx={{
                            fontSize: 16,
                            color:'#fff',
                            fontWeight: "bold",
                            fontFamily: "sans-serif",
                            //color: this.state.value == "com" ? "#00337b" : "",
                          }}
                        >
                          Commercial
                        </Typography>
                      </Grid>
                      <Grid item size={{ xs: 2 }}>
                        <Typography
                          textAlign="center"
                         // onClick={() => this.setState({ value: "cow" })}
                          sx={{
                            color:'#fff',
                            fontSize: 16,
                            fontWeight: "bold",
                            fontFamily: "sans-serif",
                            //color: this.state.value == "cow" ? "#00337b" : "",
                          }}
                        >
                          New Launch
                        </Typography>
                      </Grid>
                

                    </Grid>
                  </Box>

                  <Divider />

                  <Box sx={{ height: 73,backgroundColor:'#fff',borderRadius:10 }}>
                    <Grid container>
                      <Grid item size={{ xs: 2 }}>
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItem: "center",
                              width: "100%",
                              marginLeft: "10%",
                              marginRight: "10%",
                              justifyContent: "center",
                            }}
                          >
                            <TextField
                              id="outlined-select-currency"
                              select
                              fullWidth
                              value={city}
                              variant="standard"
                              sx={{ width: "70%", height: 70, marginTop: 2.5 }}
                              InputProps={{
                                disableUnderline: "true",
                              }}
                            >
                              {City.map((option) => (
                                <MenuItem
                                  key={option.value}
                                  onClick={()=>setCity(option.value)}
                                  value={option.value}
                                  sx={{fontSize:13}}
                                >
                                  {option.label}
                                </MenuItem>
                              ))}
                            </TextField>
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item>
                        <Divider
                          orientation="vertical"
                          flexItem
                          sx={{ height: "100%", marginLeft: 1, marginRight: 1 }}
                        />
                      </Grid>

                      <Grid item size={{ xs: 9 }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            width: "100%",
                            marginTop: 2,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItem: "center",
                              width: "100%",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "center",
                                alignItems:'center',
                                marginLeft: 1 ,
                                marginRight: 1,
                              }}
                            >

                              
                              <input type='text' placeholder='Enter Location OR search address' onFocus={resetTranscript} onChange={(e)=>
                                 setSearch(e.target.value)
                                } 
                                 value={transcript!==""? transcript +  search : search} style={{width:'100%',fontSize:15,border:0,outline:0,fontWeight:'500'}}/>
                             

                              <Box
                                 onClick={SpeechRecognition.stopListening}
                                sx={{
                                  display: "flex",
                                  borderRadius: 8,
                                  backgroundColor: "#fceaea",
                                  justifyContent: "center",
                                  mr: 2,
                                }}
                              >   
                                <CloseIcon
                                  sx={{
                                    height: 20,
                                    width: 20,
                                    m: 1,
                                    color: "red",
                                  }}
                                />
                              </Box>

                              <Box
                               onClick={SpeechRecognition.startListening}
                                sx={{
                                  display: listening? "none" : "flex",
                                  borderRadius: 8,
                                  backgroundColor: "#f0f9ff",
                                  justifyContent: "center",
                                  ml: 2,
                                  marginRight: 2,
                                }}
                              >
                                <MicIcon
                                  sx={{
                                    height: 20,
                                    width: 20,
                                    m: 1,
                                    color: "#00337b",
                                  }}
                                />
                              </Box>


                               <Box
                                sx={{
                                  display: listening? "flex" : "none",
                                  borderRadius: 8,
                                  justifyContent: "center",
                                  mr: 2,
                                }}
                              >   
                              <img src={animation} style={{height:37,width:37}}/>
                              </Box>


                              <Button
                                variant="contained"
                                onClick={() =>
                               
                                navigate('/properties',{state:{address : transcript + search, category_name : ""}})
                                  
                                }
                                size="small"
                                sx={{ textTransform: "none", marginLeft: 2 }}
                                disableElevation
                              >
                                Search
                              </Button>
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Card>



          </Container>
          </Box>
          </Box>


<br/>


<Box sx={{ display: { xs: "block", sm: "block",md:'none' }}}>
<Container maxWidth="xl">

                <Box
                  sx={{
                    display: { xs: "flex", sm: "none" },
                    flexDirection: "row",
                    mt: 3,
                    mb: 2,
                    overflowX: "scroll",
                    minHeight: 50,
                    scrollbarWidth: "none",
                  }}
                >
                  <Paper
                  
                  
                    elevation={1}
                    sx={{
                      minWidth: 140,
                      height: 47,
                      borderRadius: 8,
                      ml: 1,
                      mr: 1,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        height:37,
                        width: 37,
                        borderRadius: 8,
                        backgroundColor: "#fafcff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Diversity2Icon
                        sx={{ height: 23, width: 23, color: "#2c3089" }}
                      />
                    </Box>{" "}
                    <Typography   onClick={()=>navigate('/properties')}
                      sx={{ fontSize: 17, fontWeight: "600", mt: 0.5, ml: 0.3}}
                    >
                      Flats
                    </Typography>
                  </Paper>
     <Paper
                  
                  
                    elevation={1}
                    sx={{
                      minWidth: 140,
                      height: 47,
                      borderRadius: 8,
                      ml: 1,
                      mr: 1,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        height:37,
                        width: 37,
                        borderRadius: 8,
                        backgroundColor: "#fafcff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <Diversity2Icon
                        sx={{ height: 23, width: 23, color: "#2c3089" }}
                      />
                    </Box>{" "}
                    <Typography   onClick={()=>navigate('/properties')}
                      sx={{ fontSize: 17, fontWeight: "600", mt: 0.5, ml: 0.3}}
                    >
                      Rental
                    </Typography>
                  </Paper>
                  <Paper
                    elevation={1}
                   
                    sx={{
                      minWidth: 120,
                      height: 47,
                      borderRadius: 8,
                      ml: 1,
                      mr: 1,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        height:37,
                        width: 37,
                        borderRadius: 8,
                        backgroundColor: "#fafcff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <PersonIcon
                        sx={{ height: 23, width: 23, color: "#2c3089" }}
                      />
                    </Box>{" "}
                    <Typography   onClick={()=>navigate('/properties')}
                      sx={{ fontSize: 17, fontWeight: "600", mt: 0.5, ml: 0.3 }}
                    >
                      Plots
                    </Typography>
                  </Paper>
  
                  <Paper
                   
                    elevation={1}
                    sx={{
                      minWidth: 100,
                      height: 47,
                      borderRadius: 8,
                      ml: 1,
                      mr: 1,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        height:37,
                        width: 37,
                        borderRadius: 8,
                        backgroundColor: "#fafcff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >  
                      <VerifiedIcon
                        sx={{ height: 23, width: 23, color: "#f55904" }}
                      />
                    </Box>{" "}
                    <Typography   onClick={()=>navigate('/properties')}
                      sx={{ fontSize: 16, fontWeight: "600", mt: 0.5, ml:0.5,mr:0.5 }}
                    >
                     Land
                    </Typography>
                  </Paper>
  
                  <Paper
                  
                    elevation={1}
                    sx={{
                      minWidth: 250,
                      height: 47,
                      borderRadius: 8,
                      ml: 1,
                      mr: 1,
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        height:37,
                        width: 37,
                        borderRadius: 8,
                        backgroundColor: "#fafcff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <LandslideIcon
                        sx={{ height: 23, width: 23, color: "#2c3089" }}
                      />
                    </Box>{" "} 
                    <Typography   onClick={()=>navigate('/properties')}
                      sx={{ fontSize: 17, fontWeight: "600", mt: 0.5, ml: 0.3 }}
                    >
                      Independednt Home
                    </Typography>
                  </Paper>
  
              
                  
              
  
  
          
  
             
  
  
  
  
                </Box>


                <Box
                  sx={{
                    height: 170,
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    backgroundImage: `url(${ten})`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    borderRadius: 1,
                  }}
                >
                  <Paper
                    elevation={2}
                   // variant="outlined"
                   onClick={()=>setOpen(true)}
                    sx={{
                      width: "95%",
                      height: 47,
                      borderRadius: 2,
                      border: 0.04,
                      borderColor: "#33abdf",
                      mt: 18,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box 
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        ml: 1,
                        height: 47,
                        width: "100%",
                        justifyContent: "left",
                        alignItems: "center",
                      }}
                    >
                      <SearchIcon sx={{ color: "grey", mr: 1 }} />
                      <Typography textAlign="left" sx={{ fontSize: 14 }}>
                        Search : Name Of Place
                      </Typography>
                    </Box>
  
                    <MicIcon sx={{ mr: 1, color: "#33abdf" }} />
                  </Paper>
  
                 
  
                </Box>

</Container>
</Box>



            {
              //// search drawer
            }
            
            <Box>
            <Root>
                  <CssBaseline />
                  <Global
                    styles={{
                      '.MuiDrawer-root > .MuiPaper-root': {
                        height: '100%',
                        overflow: 'visible',
                      },
                    }}
                  />
                  <SwipeableDrawer
                   // container={container}
                    anchor="bottom"
                    open={open}
                    onClose={toggleDrawerr}
                    onOpen={toggleDrawer}
                    swipeAreaWidth={drawerBleeding}
                    disableSwipeToOpen={false}
                    ModalProps={{
                      keepMounted: true,
                    }}
                  >
                    <StyledBox
                      sx={{
                        position: 'absolute',
                        top: -drawerBleeding,
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8,
                        visibility: 'visible',
                        right: 0,
                        left: 0,
                      }}
                    >
                    </StyledBox>
            
            
                    <StyledBox sx={{  pb: 2, height: '100%', overflow: 'auto' }}>
                      <Box sx={{height:120,width:'100%',backgroundColor:'#09488b'}}>
                         <br/>
                         <Box sx={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
            
                           <Box sx={{height:47,width:260,backgroundColor:'#032851',pt:2,ml:2,borderRadius:3}}>
                           <Box sx={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center',mt:-1.1}}>
                            
                            <Box sx={{height:33,width:80,backgroundColor:'#fff',mr:0.5,ml:0.5,display:'flex',justifyContent:'center',alignItems:'center',borderRadius:2}}>
                              <Typography sx={{fontSize:12,fontWeight:'bold'}}>Flats</Typography>
                            </Box>
            
                            <Box sx={{height:33,width:80,backgroundColor:'#032851',mr:0.5,ml:0.5,display:'flex',justifyContent:'center',alignItems:'center',borderRadius:2}}>
                              <Typography sx={{fontSize:12,fontWeight:'bold',color:'#fff'}}>Home</Typography>
                            </Box>
            
                            <Box sx={{height:33,width:100,backgroundColor:'#032851',ml:0.5,mr:0.5,display:'flex',justifyContent:'center',alignItems:'center',borderRadius:2}}>
                              <Typography sx={{fontSize:12,fontWeight:'bold',color:'#fff'}}>PG/Hostel</Typography>
                            </Box>
            
                           </Box>
                          </Box> 
            
                         <Paper onClick={()=>setOpen(false)} sx={{height:30,width:30,backgroundColor:'transparent',borderRadius:5,mr:2,mt:1,display:'flex',justifyContent:'center',alignItems:'center'}}>
                           <CloseIcon sx={{color:"#fff"}}/>
                         </Paper>
            
                         </Box>
                      
                        <Paper
                              elevation={2}
                              variant="outlined"
                              sx={{
                               // width: "95%",
                                height: 47,
                                borderRadius: 2,
                               // border: 0.04,
                               // borderColor: "#33abdf",
                                ml:2,
                                mr:2,
                                mt:3,
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  ml: 1,
                                  height: 47,
                                  width: "100%",
                                  justifyContent: "left",
                                  alignItems: "center",
                                }}
                              >
                                <SearchIcon sx={{ color: "grey", mr: 1 }} />
                                <TextField variant="standard" value={transcript}  onChange={(e)=>setSearch({location_name : e.target.value})} placeholder='Search Property Location' InputProps={{disableUnderline:true,style:{fontSize:13,fontWeight:'500',color:'#09488b'}}} />
                              </Box>
                               
                               <Box onClick={SpeechRecognition.startListening} sx={{display: listening?'none':'flex',flexDirection:'row'}}>
                                  <MicIcon sx={{ mr: 1, color: "#33abdf" }} />
                               </Box>


                               <Box onClick={SpeechRecognition.stopListening} sx={{display:listening?'flex':'none',flexDirection:'row'}}>
                                  <CloseIcon sx={{ mr: 1, color: "#f29494" }} />
                               </Box>
            
            
                                <Box sx={{display:listening?'flex':'none',flexDirection:'row',mr:1}}>
                                  <img src={animation} style={{height:35,width:35}}/>
                               </Box>
                             
                             
                        </Paper>
            
                      </Box>
                      
            
            
            <Box sx={{mt:4,p:2}}>
            
            {
              props.categoryList.map((i)=>(
                 <Button variant="outlined" onClick={()=>navigate('/properties')} size='small' sx={{fontSize:10,mr:1,m:0.6,width:'auto',textTransform:'none'}} startIcon={<AddIcon />}>
                   {i.category_name}
                </Button>
              ))
            }
            
            </Box>
            
          
                  
            <Paper elevation={2} sx={{height:60,display:'flex',position:'absolute',bottom:0,left:0,right:0,justifyContent:'right',alignItems:'center'}}>
            <Button onClick={()=>{ setOpen(false); window.open('/properties')}} variant="contained" sx={{height:30,mr:2}}>Search</Button>
            </Paper>
            
            
                    </StyledBox>
                  </SwipeableDrawer>
                </Root>
            </Box>
            
       


      </div>
  );
};
export default VoiceToText;





const City = [
  {
    value: "PUNE",
    label: "PUNE",
  },
  {
    value: "MUMBAI",
    label: "MUMBAI",
  },
  {
    value: "KOLKATTA",
    label: "KOLKATA",
  },
  {
    value: "NOIDA",
    label: "NOIDA",
  },
];
